import {COOKIE_NAMES, allspiceCookies} from './allspice-cookies.ts';

export const isProjectViewEnabled = (): boolean => {
  const projectView = allspiceCookies.get(COOKIE_NAMES.PROJECT_VIEW);
  return projectView !== 'false';
};
